<template>
    <div>
        <b-card class="bg-white">
            <template v-slot:header>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <p class="mb-0" style="font-size: 21px; font-weight: bold;">Artículos Populares del Proveedor</p>
                        <small v-if="filter.dateFrom || filter.dateTo" class="text-muted">
                            Desde: {{ filter.dateFrom || 'Inicio' }} - Hasta: {{ filter.dateTo || 'Hoy' }}
                        </small>
                    </div>
                    <b-button v-b-toggle.accordion-filters-supplier-items variant="info">
                        <b-icon icon="search" aria-hidden="true"></b-icon>
                        Filtrar
                    </b-button>
                </div>
            </template>

            <b-collapse id="accordion-filters-supplier-items">
                <FilterForm
                    :filter="filter"
                    @search-result="getTopSupplierSellingItems"
                    @clear-filter-form="clearFilterForm"
                />
            </b-collapse>

            <ul class="p-0">
                <template v-if="loading">
                    <div class="text-center my-3">
                        <b-spinner small type="grow" variant="info"></b-spinner>
                        Cargando registros...
                    </div>
                </template>

                <template v-else-if="topSupplierSellingItems.length === 0">
                    <div class="text-center my-3">
                        No se encontraron registros.
                    </div>
                </template>

                <template v-else>
                    <li v-for="(item, index) in paginatedItems" :key="index" class="d-flex mb-6 item-separator">
                        <div class="mr-2">
                            <img :src="item.image" alt="Item image" class="rounded" width="70">
                        </div>
                        <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                            <div>
                                <h6 class="mb-0 item-name-ul font-weight-bold">{{ item.item_name }}</h6>
                                <small class="item-reference d-block">Item: <span class="font-weight-bold">{{ item.item_reference }}</span></small>
                            </div>
                            <div class="user-progress d-flex align-items-center gap-1">
                                <b class="item-price nowrap font-weight-bold">
                                    $ {{ numberFormat(item.precio_final_con_imp) }}
                                </b>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>

            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-number
                last-number
                size="md"
                pills
                align="right"
                class="pr-3"
            ></b-pagination>
        </b-card>
    </div>
</template>
<script>
import FilterForm from "./FilterTopSupplierItems.vue";

export default {
    data() {
        return {
            topSupplierSellingItems: [],
            perPage: 5,
            currentPage: 1,
            filter: {
                dateFrom: "",
                dateTo: new Date().toISOString().substr(0, 10),
            },
            loading: false,
        };
    },
    components: {
        FilterForm,
    },
    created() {
        this.getTopSupplierSellingItems();
    },
    computed: {
        rows() {
            return this.topSupplierSellingItems.length;
        },
        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.topSupplierSellingItems.slice(start, end);
        }
    },
    methods: {
        async getTopSupplierSellingItems() {
            this.loading = true;
            try {
                this.pageOptions = {
                    dateFrom: this.filter.dateFrom,
                    dateTo: this.filter.dateTo,
                };

                const response = await this.$conectar.post("dashboard/get-top-supplier-selling-items", this.pageOptions);
                this.topSupplierSellingItems = response.data.topSupplierSellingListItems || [];
                this.currentPage = 1;
            } catch (error) {
                console.error("Error al obtener artículos más vendidos:", error);
                this.topSupplierSellingItems = [];
            }
            this.loading = false;
        },
        
        clearFilterForm() {
            this.filter.dateFrom = "";
            this.filter.dateTo = new Date().toISOString().substr(0, 10);
            this.getTopSupplierSellingItems();
        },
    }
};
</script>

<style scoped>
.card-header {
    background-color: white !important;
    padding: 10px 10px;
}

.item-name-ul {
    max-width: 300px;
    word-wrap: break-word;
    font-size: 16px;
}

.item-reference {
    font-size: 16px;
}

.item-price {
    font-size: 18px;
}

.item-separator {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
</style>
